export default "__VITE_ASSET__omu3M3qd__"